import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';

// Import BCE Theme
import bceTheme from './theme';

// Import AWS Amplify configuration
import './lib/aws-config';

// Import authentication
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Import pages and components
import Header from './components/Header';
import SOWGenerator from './components/SOWGenerator';
import Auth from './pages/Auth';
import DocumentManager from './components/DocumentManager';

// Layout component to conditionally show header
function AppLayout() {
  const location = useLocation();
  const hideHeader = location.pathname === '/auth';

  return (
    <div className="App">
      {!hideHeader && <Header />}
      <Routes>
        {/* Public route - Authentication */}
        <Route path="/auth" element={<Auth />} />
        
        {/* Protected routes - Require authentication */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <SOWGenerator />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/documents" 
          element={
            <ProtectedRoute>
              <DocumentManager />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={bceTheme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppLayout />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;